// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#package-version{display:none!important}#cms-content{margin-top:72px!important}.controller-header-bottom{height:auto}button,button:focus{outline:2px solid transparent;outline-offset:2px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
